import React, { useState, useEffect } from "react";
import { TextField, Typography, Box } from "@mui/material";
import removeAccents from "./removeAccents";

const CustomAutocomplete = ({ options, label, onChange, disabled, value }) => {
    const [inputValue, setInputValue] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        if (inputValue) {
            const filtered = options.filter(option =>
                removeAccents(option.name).toLowerCase().includes(removeAccents(inputValue).toLowerCase())
            );
            setFilteredOptions(filtered);
        } else {
            setFilteredOptions(options);
        }
    }, [inputValue, options]);

    const handleOptionClick = (option) => {
        setInputValue(option.name);
        setIsDropdownOpen(false);
        onChange(option);
    };

    useEffect(() => {
        setInputValue(value)
    },[value])

    return (
        <Box sx={{ position: "relative", width: "300px" }}>
            <TextField
                variant="standard"
                label={label}
                fullWidth
                value={inputValue}
                autoComplete={'off'}
                onChange={(e) => {
                    setInputValue(e.target.value);
                    setIsDropdownOpen(true);
                }}
                onFocus={() => setIsDropdownOpen(true)} // Open dropdown on focus
                onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)} // Close dropdown after blur
                disabled={disabled}
            />
            {isDropdownOpen && filteredOptions.length > 0 && (
                <Box
                    sx={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "250px",
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        backgroundColor: "#fff",
                        zIndex: 1,
                    }}
                >
                    {filteredOptions.map((option) => (
                        <Box
                            key={option.id}
                            sx={{
                                height: '100%',
                                padding: "8px",
                                cursor: "pointer",
                                "&:hover": { backgroundColor: "#f0f0f0" },
                            }}
                            onClick={() => handleOptionClick(option)}
                        >
                            <Typography>{option.name}</Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default CustomAutocomplete;